import Switch from "./Switch"

export const validationPatterns = {
    "numeric": {
        value: /^[0-9]+$/,
        message: "Please enter numbers only"
    },
    "email": {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        message: "Invalid Email Address"
    },
    "phone": {
        value: /^[-+]?[0-9]+$/,
        message: "Invalid phone number format"
    },
}

export function SwitchInput({ label, states = ["", ""], setValue }) {
    return (
        <>
            <label className="text-gray-600 font-medium capitalize truncate">{label}</label>
            <Switch states={states} setValue={setValue} capsTitle />
        </>
    )
}

export function Input({ name, value, type, onChange, placeholder, maxLength, required, pattern, register }) {

    return (
        <input
            name={name}
            type={type ?? "text"}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            // pattern={pattern}
            className={`
                h-12 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50
            `}
            ref={register?.({
                //pattern takes an object. !Must also default to empty object to work (phew!!!)
                pattern: pattern ? validationPatterns[pattern] : {},
                required: required ? "This field is required" : false,
                maxLength,
            })}
        />
    )
}

export function InputWithLabel({ name, label, type, register, errors, pattern, defaultValue, placeholder, required }) {
    label = label ?? name.replace(/[\W_]+/g, " ")

    return (
        <div className="space-y-2" key={label + name}>
            <label htmlFor={name} className="block capitalize text-gray-500 text-sm">{label}</label>
            <input
                name={name}
                type={type ?? "text"}
                defaultValue={defaultValue}
                placeholder={placeholder}
                className={`
                    h-12 block w-full rounded-md focus:ring focus:ring-indigo-200 focus:ring-opacity-50 placeholder-gray-400
                    ${errors[name] ?
                        "border-red-500 focus:border-red-300 focus:ring-red-200" :
                        "border-gray-300 focus:border-indigo-300 focus:ring-indigo-200"
                    }
                `}
                ref={register?.({
                    //pattern takes an object. !Must also default to empty object to work (phew!!!)
                    pattern: pattern ? validationPatterns[pattern] : {},
                    required: required ? "This field is required" : false,
                })}
            />
            {errors[name] && <span className="block text-red-600 text-sm">{errors[name].message}</span>}
        </div>
    )
}